import { toast } from "sonner";
import { t } from "i18next";

// Endpoints that send email answer 201 when every email went out, 207 when only some did, and 502
// when none did (ID-7088). A 207 still lands in onSuccess -- the client treats any 2xx as success --
// so the body's failedRecipients is what tells the two apart. A backend from before ID-7088 sends no
// failedRecipients (POST /users sent a bare id), so a missing one reads as "all sent" -- the two
// repos deploy independently and either may land first.
export const showEmailOutcomeToast = (
  outcome: { failedRecipients?: string[] } | number | null | undefined,
  messages: { partial: string; success?: string },
) => {
  const failedRecipients =
    typeof outcome === "object" ? (outcome?.failedRecipients ?? []) : [];
  if (failedRecipients.length > 0) {
    toast.warning(messages.partial, {
      description: t("emailsNotSentTo", {
        emails: failedRecipients.join(", "),
      }),
    });
  } else if (messages.success) {
    toast.success(messages.success);
  }
};
